import classNames from "classnames";
import PropTypes from "prop-types";
import { MdLocalFireDepartment } from "react-icons/md";

const HotModeToggle = ({ active, onToggle, label }) => (
  <button
    type="button"
    aria-pressed={active}
    className={classNames("projects-scope-toggle__btn", "hot-mode-toggle", {
      "projects-scope-toggle__btn--active": active,
      "hot-mode-toggle--active": active,
    })}
    onClick={onToggle}
  >
    <MdLocalFireDepartment className="projects-scope-toggle__icon" size={18} />
    <span className="projects-scope-toggle__label">{label}</span>
  </button>
);

HotModeToggle.propTypes = {
  active: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
};

export default HotModeToggle;
